import React, { useState } from 'react';

import Banner from '../banner/Banner';
import Camera from '../camera/Camera';
import MpDisplay from '../mpDisplay/MpDisplay';
import SidePanel from '../sidePanel/SidePanel';

const apiHost = 'http://localhost:8081';

function App() {
    const [sidePanelOpen, setSidePanelOpen] = useState(false);    
    const [appMode, setAppMode] = useState('CAMERA');  
    const [mpSettings, setMpSettings] = useState({
            faceImageBase64:null,
            makeup: {
                hair:-1,
            },        
        });
    // function to handle when camera button is clicked
    const handleCameraButtonClick = faceImageBase64 => {
        setMpSettings({
            ...mpSettings,
            faceImageBase64: faceImageBase64,
        });
        setAppMode('AVATAR');
    }
    const appStyle = {
        background: 'grey',
        height: '100vh',      
    };
    const mainStyle = {
        display:'flex',
        marginTop:'50px',
    };
    
    return (
        <div className="App" style={appStyle}>
            <Banner sidePanelToggle={_ => setSidePanelOpen(!sidePanelOpen)} />
            <main style={mainStyle}>
                <div id='left-grow' style={{ flexGrow: 1 }}></div>
                {appMode === 'CAMERA' && <Camera
                    onClick={faceImageBase64 => handleCameraButtonClick(faceImageBase64)}
                />}
                <MpDisplay
                    appMode={appMode}                    
                    settings={mpSettings} 
                    apiHost={apiHost}                   
                />                                
                <div id='right-column' style={{ width: '45vw' }}></div>
            </main>
            <SidePanel
                open={sidePanelOpen}
                onClose={_ => setSidePanelOpen(false)}
                setMakeup={(name, setting) => {
                    const settings = {
                        ...mpSettings,                        
                        makeup: {
                            ...mpSettings.makeup,
                            [name]: setting
                        }                        
                    };
                    setMpSettings(settings)                    
                }}
            />
        </div>
    );
}

export default App;
